'use client';

import {
    Align,
    Box,
    BoxContent,
    DirectionEnum,
    FlexBox,
    FlexItem,
    GapSize,
    Icon,
    IconName,
    IconSize,
    Text,
    TextLevels,
    TrilogyColor,
    TypographyBold,
} from '@bytel/trilogy-react';

import { InlinePrice } from '@components/inline-price';

interface TradeInBonusInfoProps {
    tradeInBonus?: number;
    showExtraWording?: boolean;
}

export function TradeInBonusInfo({ tradeInBonus, showExtraWording = true }: Readonly<TradeInBonusInfoProps>) {
    if (!tradeInBonus) {
        return null;
    }

    return (
        <FlexBox direction={DirectionEnum.COLUMN} gap={GapSize.TWO}>
            {showExtraWording && (
                <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} level={TextLevels.TWO} marginless>
                    Bonne nouvelle, vous bénéficiez de&nbsp;:
                </Text>
            )}
            <Box
                highlighted={TrilogyColor.ACCENT}
                className='box-thin'
                shadowless
                backgroundColor={TrilogyColor.ACCENT_FADE}
            >
                <BoxContent>
                    <FlexBox direction={DirectionEnum.ROW} align={Align.CENTER} gap={2}>
                        <FlexItem narrow>
                            <Icon color={TrilogyColor.ACCENT} name={IconName.PROMO} size={IconSize.SMALL} />
                        </FlexItem>
                        <FlexBox>
                            <Text level={TextLevels.TWO} marginless>
                                <InlinePrice level={TextLevels.TWO} amount={tradeInBonus} />
                                &nbsp;de bonus avec la reprise mobile
                            </Text>
                        </FlexBox>
                    </FlexBox>
                </BoxContent>
            </Box>
        </FlexBox>
    );
}
